var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"white-bg"}}),_vm._v(" "),_c('div',{attrs:{"id":"work-container"}},[_c('header',[_c('div',{staticClass:"bg",style:({'background-image': _vm.getHeaderBg})}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.shared.state.project.fields.title))])]),_vm._v(" "),_c('article',{domProps:{"innerHTML":_vm._s(_vm.compiledMD)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a9f0b2b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkView.vue
// module id = null
// module chunks = 